import React from "react";
import "../../Styles/Contacts/Contacts.css"
import ContactForm from "./ContactForm";
function Contacts({ resume, first_name, last_name, handleRobotText }) {
  const [animate, setAnimate] = React.useState(false);
  return (
    <section className="contacts" id="contacts">
      <div className="contactContainer flexBox">
        <div className="contactBanner flexBox">
          <div className="contactBannerDetails flexBox">
            <h1>Let's make something amazing together.</h1>
            <h1
              onMouseEnter={() =>
                handleRobotText("Do you want to send a message...?")
              }
            >
              Starts by{" "}
              <span
                onMouseEnter={() => setAnimate(true)}
                onMouseLeave={() => setAnimate(false)}
              >
                saying hi
              </span>
            </h1>
            <a
              onMouseEnter={() => handleRobotText("Do you need a CV copy...?")}
              href={resume}
              download={`${first_name} ${last_name}`}
              target="_blank"
              rel="noopener noreferrer"
              className="download"
            >
              Download CV
            </a>
          </div>
        </div>
        <div className="contactBox flexBox">
          <div className="contactInformation">
            <small>Information</small>
            <p>Sirsi, Karntaka, India</p>
            <h1>darshu8314@gmail.com</h1>
            <ContactForm animate={animate} handleRobotText={handleRobotText} />
          </div>
        </div>
      </div>
      <footer className="footer flexBox">
        <div className="footerCopyRights flexBox">
          <h2>
            {first_name || "Darshan"} <span>{last_name || "Naik"}</span>
          </h2>

          <p>
            {" "}
            <span>©</span> 2021. All Rights Reserved
          </p>
        </div>
        <div className="socialIcons flexBox">
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://twitter.com/Darshan_Naik_"
            className="social glass flexBox"
          >
            <img
              src={process.env.PUBLIC_URL + "/images/twitter.png"}
              alt="Link"
            />
            <span>Twitter</span>
          </a>
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://www.linkedin.com/in/darshannaik1995/"
            className="social glass flexBox"
          >
            <img
              src={process.env.PUBLIC_URL + "/images/linkedin.png"}
              alt="Link"
            />
            <span>LinkedIn</span>
          </a>
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://github.com/Darshan-Naik"
            className="social glass flexBox"
          >
            <img
              src={process.env.PUBLIC_URL + "/images/git_icon.png"}
              alt="Link"
            />
            <span>Github</span>
          </a>
        </div>
      </footer>
    </section>
  );
}

export default Contacts;
